// extracted by mini-css-extract-plugin
export default {"container":"WorkoutLogo_container__vKX5D","image":"WorkoutLogo_image__VehLS"};